import { useDroppable } from '@dnd-kit/core';
import { PlanningEntityIdentifier, PlanningEntityType } from 'generated';

import { Box } from '@mui/material';

import DropIndicator from '../DropIndicator/DropIndicator';

interface DropZoneProps {
  id: string;
  scheduleStart: string;
  start: string;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
}

export default function Dropzone({
  id,
  scheduleStart,
  start,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier
}: DropZoneProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      scheduleStart,
      start,
      planningEntityType,
      planningEntityId,
      planningEntityIdentifier
    }
  });

  return (
    <Box
      component="li"
      ref={setNodeRef}
      display="flex"
      flexShrink={0}
      className="dropzone"
      justifyContent="center"
      alignItems="center"
      sx={{
        boxSizing: 'border-box',
        minHeight: '8px',
        width: '100%',
        color: '#6b6b6b',
        fontSize: '10px',
        height: '30px',
        margin: '-10px 0',
        '&:first-of-type': {
          marginTop: '-20px'
        }
      }}
    >
      {isOver && <DropIndicator className="dropzone__indicator" />}
    </Box>
  );
}
